import React, { memo, useMemo } from "react";
import styles from "./ProviderPrivateHeader.module.scss";
import UserInfoDropdown from "../../../common/components/user-info-dropdown/UserInfoDropdown";
import { MobileMenu, NotificationIcon } from "../../../assets/icons";
import { useLocation } from "react-router-dom";
import { getUserType } from "../../../guards/common/authentification-functions";
import { UserType } from "../../../model/userType";

type Props = {
	isColapsed: boolean;
	onMenuClick: () => void;
	onMobileMenuClick: () => void;
};

/*
Used for provider user
*/

const ProviderPrivateHeader: React.FC<Props> = memo((props: Props) => {
	const { onMenuClick, onMobileMenuClick, isColapsed } = props;
	const { pathname } = useLocation();
	let userType = getUserType();

	const title = useMemo(()=>{ 
		switch(pathname){
			case "/dashboard":
				return "Dashboard";
			default :return "";

		}
	},[pathname])
	

	return (
		<div>
			<div className={`${styles.container} ${isColapsed ? styles.colapsed : ""}`}>
				<div className={`${styles.logoContainer} ${styles.logoContainerColapsed}`}>
					<a href={userType === UserType.BPSAdmin? "/admin/home": '/provider/dashboard'}>
					<img className={styles.logo} src="../../../images/ekedc/logo.png" alt="placeholder" />
					</a>
				</div>
				<button className={`standardButton ${styles.button}`} onClick={onMenuClick}>
					<svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M0.5 11V9.49998H5.87498V11H0.5ZM0.5 6.24995V4.75H11.6827V6.24995H0.5ZM0.5 1.49998V0H17.5V1.49998H0.5Z" fill="#1C1B1F" />
					</svg>
				</button>
				<UserInfoDropdown />
			</div>
			<div className={styles.mobileContainer}>
				<MobileMenu className={styles.mobileMenu} onClick={onMobileMenuClick} />
				<span className={styles.header}>{title}</span>
			</div>
		</div>
	);
});

export default ProviderPrivateHeader;
